import { render, staticRenderFns } from "./CustomRoundBtn.vue?vue&type=template&id=e4c01d44&scoped=true&lang=pug&"
import script from "./CustomRoundBtn.vue?vue&type=script&lang=js&"
export * from "./CustomRoundBtn.vue?vue&type=script&lang=js&"
import style0 from "./CustomRoundBtn.vue?vue&type=style&index=0&id=e4c01d44&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c01d44",
  null
  
)

export default component.exports